/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { ntxAPI } from '../../../../API/axiosNeatex';
import {type  FormikProps } from 'formik';
import useLookupPeopleCode from '../../../../hooks/Lookups/use-Get_PEOPLE_CODE';

interface Props {
  formik: FormikProps<any>;
}

interface Option {
  value: string;
  label: string;
}

// const Reference: React.FC<Props> = ({ formik }) => {
//   const { values } = formik;
//   const { t, i18n } = useTranslation();
//   const [data, setData] = useState<Option[]>([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const { OptionsPeopleCode } = useLookupPeopleCode();

//   const GetData = useCallback(async () => {
//     var url = '';
//     if (values.userType === 'EMPLOYEE') {
//       url = 'Persons/GetPersonLookup';
//     } else {
//       url = `Peoples/GetNtxPeoplesList?LookupType=${values.userType}`;
//     }

//     if (!url) {
//       setData([]);
//       setIsLoading(false);
//       return;
//     }

//     try {
//       // debugger;
//       const { data } = await ntxAPI.get(url);

//       if (data?.succeeded || data?.data?.length) {
//         // debugger;
//         const formattedData = data?.data.map((item: any) => ({
//           label: i18n.language === 'en' ? item.name : item.name2,
//           value: item.id,
//         }));
//         setData(formattedData);
//       } else {
//         setError('Error !!');
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setError('Error !!');
//     } finally {
//       setIsLoading(false);
//     }
//   }, [values.userType]);

//   useEffect(() => {
//     GetData();
//   }, [GetData]);

//   useEffect(() => {
//     formik?.setFieldValue('referenceId', null);
//   }, [values.userType]);

//   return (
//     <>
//       <label className="form-label">
//         {(() => {
//           switch (values.userType) {
//             case 'EMPLOYEE':
//               return t('Employees');
//             default:
//               const label = OptionsPeopleCode?.find((f: any) => f.value === values.userType).label;
//               return label;
//           }
//         })()}
//       </label>
//       <Select
//         isLoading={isLoading}
//         classNamePrefix="react-select"
//         isClearable
//         isSearchable
//         options={data}
//         value={data?.find((f) => f.value === values?.referenceId) || null}
//         onChange={(option: Option | null) => {
//           formik.setFieldValue('referenceId', option ? option.value : null);
//         }}
//         placeholder={isLoading ? 'جاري تحميل البيانات' : error ? 'فشل تحميل البيانات' : 'اختر'}
//       />
//     </>
//   );
// };

// export default Reference;

const Reference: React.FC<Props> = ({ formik }) => {
  const { values, setFieldValue } = formik;
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<Option[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { OptionsPeopleCode } = useLookupPeopleCode();

  const fetchData = useCallback(async () => {
    if (!values.userType) {
      setData([]);
      setIsLoading(false);
      return;
    }

    const url =
      values.userType === 'EMPLOYEE'
        ? 'Persons/GetPersonLookup'
        : `Peoples/GetNtxPeoplesList?LookupType=${values.userType}`;

    setIsLoading(true);
    setError(null);

    try {
      const response = await ntxAPI.get(url);
      if (response.data?.succeeded || response.data.data?.length) {
        const formattedData = response.data.data.map((item: any) => ({
          label: i18n.language === 'en' ? item.name : item.name2,
          value: item.id
        }));
        setData(formattedData);
      } else {
        setError(t('error.fetchingData'));
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setError(t('error.fetchingData'));
    } finally {
      setIsLoading(false);
    }
  }, [values.userType, i18n.language, t]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // useEffect(() => {
  //   setFieldValue('referenceId', null);
  // }, [values.userType, setFieldValue]);

  const getLabel = () => {
    if (values.userType === 'EMPLOYEE') {
      return t('Employees');
    }
    const selectedOption = OptionsPeopleCode?.find((f: any) => f.value === values.userType);
    return selectedOption ? selectedOption.label : '';
  };

  return (
    <>
      <label className='form-label'>{getLabel() || '.'}</label>
      <Select
        isLoading={isLoading}
        classNamePrefix='react-select'
        isClearable
        isSearchable
        options={data}
        value={data.find(f => f.value === values.referenceId) || null}
        onChange={(option: Option | null) => {
          setFieldValue('referenceId', option ? option.value : null);
        }}
        placeholder={isLoading ? t('.') : error ? t('error.loadingData') : t('Choose')}
      />
    </>
  );
};

export default Reference;
